import _ from './ghost-comment.style.scss';

export default angular.module('directives.ghostComment', [])
  .directive('ghostComment', function () {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./ghost-comment.template.html')
    }
  })
  .name;